import { put, takeLatest } from "redux-saga/effects";
import { fetchMyPeers } from "src/redux/actions";

export function* fetchMyPeersList({ payload }: { type: "GET_MY_PEERS_LIST"; payload: "ACTIVE" | "EXPIRED" }) {
  try {
    const { entities } = yield fetchMyPeers(payload);

    yield put({
      payload: entities,
      type: "GET_MY_PEERS_LIST_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      type: "GET_MY_PEERS_LIST_REJECTED"
    });
  }
}

export default function* myPeersWatcher() {
  yield takeLatest("GET_MY_PEERS_LIST", fetchMyPeersList);
}
